import { useState } from "react";
import l from "../../../services/api/Landings";
import b from "../../../services/api/Boards";

export function useLeadEditing({questId, columns, setColumns, crmColumnUpdateRef, alert, isSliderOpen,
    setIsSliderOpen, shareToken = "" }) {
  const [editingLead, setEditingLead] = useState(null);
  const [originalColumnId, setOriginalColumnId] = useState(null);
  const [activeColumnId, setActiveColumnId] = useState(null);


  /** Open Lead Editor */
  const openLeadEditor = (colId, lead) => {

    console.log('LEAD@@@@@', lead);
    
    setEditingLead(lead);
    setOriginalColumnId(colId);
    setActiveColumnId(colId);
    setIsSliderOpen('edit');
  };

  /** ---- SAVE LEAD & HANDLE COLUMN MOVEMENT ---- */
//   const saveLead = async () => {

//     if (!editingLead) return;

//     try {
//       const payload = { ...editingLead };
//       const res = await api.leads.editLead(payload);
//       const savedLead = res?.data?.form || payload;
//       const finalLead = { ...savedLead, id: savedLead._id || editingLead._id };

//       // UPDATE UI
//       setColumns(prev => {
//         const updated = { ...prev };
//         Object.keys(updated).forEach(colId => {
//           updated[colId].items = updated[colId].items.map(l =>
//             (l._id || l.id) === finalLead.id ? finalLead : l
//           );
//         });
//         return updated;
//       });

//       /** If user changed the column */
//       if (originalColumnId && activeColumnId !== originalColumnId) {
//         await api.board.moveLead({
//           questId,
//           leadId: finalLead.id,
//           fromColumnId: originalColumnId,
//           toColumnId: activeColumnId,
//           beforeId: null,
//           afterId: null,
//         });
//       }

//       closeLeadEditor();
//     } catch (err) {
//       console.error("saveLead failed:", err);
//       alert("Failed to save lead");
//     }
//   };


const saveLead = async (leadOverride = null, options = {}) => {
  const leadToSave = leadOverride || editingLead;
  if (!leadToSave) return;

  const { closeEditor = true } = options;

  try {

    console.log('HERE', leadToSave);
    
    const payload = { ...leadToSave };
    delete payload.Notes;


    console.log('HERE2', leadToSave);

 
    const res = await l.editLead(payload);
    const savedLead = res?.data?.form;

    if (!savedLead) {
      throw new Error(res?.data?.error || "The lead was not saved");
    }


    console.log('!!!!!!savedLead', savedLead, res?.data?.form );
    
    const finalLead = {
      ...leadToSave,
      ...savedLead,
      Notes: Array.isArray(leadToSave?.Notes)
        ? leadToSave.Notes
        : (savedLead?.Notes || []),
      id: savedLead._id || leadToSave._id,
    };

    const columnChanged =
      originalColumnId &&
      activeColumnId &&
      originalColumnId !== activeColumnId;

    setColumns(prev => {
      const updated = { ...prev };

      // If column did NOT change → just update the lead in-place
      if (!columnChanged) {
        Object.keys(updated).forEach(colId => {
          updated[colId] = {
            ...updated[colId],
            items: (updated[colId].items || []).map(l =>
              (l._id || l.id) === finalLead.id ? finalLead : l
            ),
          };
        });
        return updated;
      }

      // Column CHANGED → remove from old column & add to new column
      const fromCol = updated[originalColumnId];
      const toCol = updated[activeColumnId];

      if (!fromCol || !toCol) return updated;

      const fromItems = (fromCol.items || []).filter(
        l => (l._id || l.id) !== finalLead.id
      );

      // Avoid duplicates in target column just in case
      const existingIndex = (toCol.items || []).findIndex(
        l => (l._id || l.id) === finalLead.id
      );
      const baseToItems =
        existingIndex >= 0
          ? toCol.items.filter((_, idx) => idx !== existingIndex)
          : (toCol.items || []);

      const toItems = [finalLead, ...baseToItems]; // prepend or append, your choice

      updated[originalColumnId] = {
        ...fromCol,
        items: fromItems,
        leadCount: Math.max(0, Number(fromCol.leadCount ?? fromCol.items.length) - 1),
      };
      updated[activeColumnId] = {
        ...toCol,
        items: toItems,
        leadCount: Number(toCol.leadCount ?? toCol.items.length) + 1,
      };

      return updated;
    });

    // Backend move so it persists
    if (columnChanged) {
      await b.moveLead({
        questId,
        leadId: finalLead.id,
        fromColumnId: originalColumnId,
        toColumnId: activeColumnId,
        beforeId: null,
        afterId: null,
        shareToken,
      });

      // ⬇️ If you still have the table ref, you can update it here:
      if (crmColumnUpdateRef?.current) {
        crmColumnUpdateRef.current(finalLead.id, activeColumnId);
      }
    }

    if (closeEditor) {
      closeLeadEditor();
    } else {
      setEditingLead(finalLead);
      if (activeColumnId) setOriginalColumnId(activeColumnId);
    }

    return finalLead;
  } catch (err) {
    console.error("saveLead failed:", err);
    alert("Failed to save lead");
    return false;
  }
};

  const closeLeadEditor = () => {
    setEditingLead(null);
    setActiveColumnId(null);
    setOriginalColumnId(null);
    setIsSliderOpen(false);
  };

  /** Move lead locally between columns instantly */
  const moveLeadBetweenColumns = (lead, from, to) => {
    setColumns(prev => {
      const updated = { ...prev };
      updated[from].items = updated[from].items.filter(
        l => (l._id || l.id) !== lead.id
      );
      updated[from].leadCount = Math.max(
        0,
        Number(updated[from].leadCount ?? updated[from].items.length) - 1
      );
      updated[to].items = [lead, ...updated[to].items];
      updated[to].leadCount = Number(updated[to].leadCount ?? updated[to].items.length) + 1;
      return updated;
    });
  };

  return {
    editingLead,
    setEditingLead,
    activeColumnId,
    setActiveColumnId,
    originalColumnId,
    openLeadEditor,
    saveLead,
    closeLeadEditor,
    moveLeadBetweenColumns,
    isSliderOpen,
    setIsSliderOpen,
  };
}
